/**
 * Ronde 3 — PR-4 Consignatie filter-helpers.
 *
 * Bronspec: docs/specs/ronde-3/02-consignatie-planning-facturatie.md §5 +
 * §7 ("Bezetting en overzichten") + §13 Business Rule R4 ("Niet in bezetting").
 *
 * Consignatie-werkbonnen tellen NIET mee in productiviteits- en capaciteits-
 * aggregaties. Reden: een monteur die op weeknacht standby staat heeft daarmee
 * géén verbruikte arbeidsuren — alleen bij oproep wordt arbeid geleverd, en
 * die oproep-uren komen via een aparte factuurregel (CONSIGNATIE_OPROEP).
 *
 * Gebruik in API-routes:
 *
 *   import { EXCLUDE_CONSIGNATIE, EXCLUDE_CONSIGNATIE_WERKBON } from '@streep/utils'
 *
 *   // Op WerkbonDayEntry-query (productiviteitsrapportage):
 *   db.werkbonDayEntry.findMany({
 *     where: { deletedAt: null, ...EXCLUDE_CONSIGNATIE, ... },
 *   })
 *
 *   // Op Werkbon-query (top-level rapportage):
 *   db.werkbon.aggregate({
 *     where: { deletedAt: null, ...EXCLUDE_CONSIGNATIE_WERKBON, ... },
 *   })
 *
 * NB: deze helpers retourneren `werkbon.isConsignatie: false` — werkbonnen
 * waar de vlag NIET gezet is (=alle bestaande historische werkbonnen) blijven
 * meegeteld. Soft-deleted dayEntries (`deletedAt: null` filter blijft caller-
 * verantwoordelijkheid).
 */

/**
 * Where-fragment op `WerkbonDayEntryWhereInput` — gebruik via spread:
 *
 *   { where: { ...EXCLUDE_CONSIGNATIE, deletedAt: null } }
 */
export const EXCLUDE_CONSIGNATIE = {
  werkbon: { isConsignatie: false },
} as const

/**
 * Where-fragment op `WerkbonWhereInput` — gebruik via spread:
 *
 *   { where: { ...EXCLUDE_CONSIGNATIE_WERKBON, deletedAt: null } }
 */
export const EXCLUDE_CONSIGNATIE_WERKBON = {
  isConsignatie: false,
} as const

/**
 * Kantoor interne bon (S3) — interne (kantoor) werkbonnen tellen NIET mee in
 * facturatie en externe rapportages. Mirror van `EXCLUDE_CONSIGNATIE_WERKBON`.
 * Where-fragment op `WerkbonWhereInput` — gebruik via spread:
 *
 *   { where: { ...EXCLUDE_INTERN_WERKBON, deletedAt: null } }
 */
export const EXCLUDE_INTERN_WERKBON = {
  isIntern: false,
} as const
